import { createClient } from '@supabase/supabase-js'

// Capture recovery state from URL hash before Supabase consumes it
if (window.location.hash.includes('type=recovery')) {
  sessionStorage.setItem('4lc_password_recovery', 'true')
}

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)